import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
const DIRECTION = {
	UP: 'up',
	DOWN: 'down',
	LEFT: 'left',
	RIGHT: 'right',
};

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const CaretIcon = ({size, color, onClick, direction, title}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '3';
			case SIZE.STANDARD:
				return '12';
			default:
				return '12';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '12';
			case SIZE.STANDARD:
				return '12';
			default:
				return '12';
		}
	};

	const getRotation = direction => {
		switch (direction) {
			case DIRECTION.UP:
				return 180;
			case DIRECTION.RIGHT:
				return 90;
			case DIRECTION.DOWN:
				return 0;
			case DIRECTION.LEFT:
				return 270;
			default:
				return 0;
		}
	};
	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} canClick={onClick !== undefined} width={getWidth(size)} height={getHeight(size)}>
			<svg className={'caret-icon'} width={getWidth(size)} height={getHeight(size)} viewBox="0 0 6 12">
				<title>{title}</title>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Artboard" transform="translate(-363.000000, -2406.000000)" fill={color} fillRule="nonzero">
						<path
							d="M370.379216,2409.20657 C370.812197,2408.87871 371.441132,2408.94858 371.783982,2409.36263 C372.126831,2409.77668 372.053765,2410.37812 371.620784,2410.70598 L365.950027,2414.99996 L360.381167,2410.80464 C359.947335,2410.47781 359.872705,2409.87655 360.214477,2409.46169 C360.556249,2409.04682 361.185,2408.97546 361.618833,2409.30229 L365.946858,2412.56282 L370.379216,2409.20657 Z"
							id="Arrow-right"
							transform={`translate(365.999999, 2411.999960) scale(-1, 1) rotate(${getRotation(
								direction
							)}) translate(-365.999999, -2411.999960)`}
							className={'caret-icon-path'}
						></path>
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};
CaretIcon.SIZE = SIZE;
CaretIcon.DIRECTION = DIRECTION;
CaretIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	direction: PropTypes.oneOf([DIRECTION.UP, DIRECTION.LEFT, DIRECTION.RIGHT, DIRECTION.DOWN]),
	title: PropTypes.string,
};

CaretIcon.defaultProps = {
	color: '#535353',
};
const StyledSpan = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
	cursor: ${({canClick}) => (canClick ? 'pointer' : 'normal')};
	transform: ${props => {
		switch (props.direction) {
			case DIRECTION.DOWN:
				return 'rotate(90deg)';
			case DIRECTION.LEFT:
				return 'rotate(180deg)';
			case DIRECTION.UP:
				return 'rotate(270deg)';
			default:
				return '';
		}
	}}
`;
